module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_iterators.js
// module id = 40
// module chunks = 0